import { toUnixTimestamp } from "core/model/utils/dates";
import type { ClinicalPatient, ClinicalPatientDiagnosis } from "core/types";
import type { DoctorDashboardTableRow } from "./DoctorDashboardTable";

function formatMainDiagnosisLine1(
  diagnosis: ClinicalPatientDiagnosis | null | undefined,
): string {
  if (!diagnosis) return "";
  const main = diagnosis.main_diagnosis?.trim();
  if (main) return main;
  const hl7 = diagnosis.hl7_main_diagnoses ?? [];
  return (
    hl7
      .map((d) => d.description ?? d.code ?? "")
      .filter(Boolean)
      .join(", ") ?? ""
  );
}

function formatMainDiagnosisLine2(
  diagnosis: ClinicalPatientDiagnosis | null | undefined,
): string {
  if (!diagnosis) return "";
  const hl7 = diagnosis.hl7_main_diagnoses ?? [];
  const codes = hl7.map((d) => d.code ?? "").filter(Boolean);
  return codes.join(", ") ?? "";
}

export function mapClinicalPatientToTableRow(
  patient: ClinicalPatient,
): DoctorDashboardTableRow {
  const profile = patient.profile;
  const diagnosis = patient.diagnosis;
  return {
    birthDate: profile?.birth_date ?? undefined,
    dischargeDate: toUnixTimestamp(profile?.discharge_date) ?? undefined,
    externalId: patient.external_id,
    firstName: profile?.first_name ?? undefined,
    gender: profile?.gender ?? undefined,
    id: patient.id,
    lastName: profile?.last_name ?? undefined,
    mainDiagnosisLine1: formatMainDiagnosisLine1(diagnosis),
    mainDiagnosisLine2: formatMainDiagnosisLine2(diagnosis),
    userId: patient.user_id,
  };
}
